<template>
	<div class="Ausbildungsgrade">
		<div class="container">
			<h1>{{ $t('navigationAusbildungsgrade.title') }}</h1>
			<div class="row align-items-center h-50">
				<div class="py-5 col-9">
					<div class="mb-3">
						{{ $t('navigationAusbildungsgrade.text.absatz1') }}
						{{ $t('navigationAusbildungsgrade.text.absatz2') }}
					</div>
					<div class="mb-5">
						{{ $t('navigationAusbildungsgrade.text.absatz3') }}
						{{ $t('navigationAusbildungsgrade.text.absatz4') }}
					</div>
					<div class="mb-5">
						{{ $t('navigationAusbildungsgrade.kampfphasen.absatz1') }}
						<ul class="mt-4">
							<li>
								<h5>
									{{
										$t(
											'navigationAusbildungsgrade.kampfphasen.phasen.phase1.title'
										)
									}}
								</h5>
								<div>
									{{
										$t(
											'navigationAusbildungsgrade.kampfphasen.phasen.phase1.description'
										)
									}}
								</div>
							</li>
							<li>
								<h5>
									{{
										$t(
											'navigationAusbildungsgrade.kampfphasen.phasen.phase2.title'
										)
									}}
								</h5>
								<div>
									{{
										$t(
											'navigationAusbildungsgrade.kampfphasen.phasen.phase2.description'
										)
									}}
								</div>
							</li>
							<li>
								<h5>
									{{
										$t(
											'navigationAusbildungsgrade.kampfphasen.phasen.phase3.title'
										)
									}}
								</h5>
								<div>
									{{
										$t(
											'navigationAusbildungsgrade.kampfphasen.phasen.phase3.description'
										)
									}}
								</div>
							</li>
							<li>
								<h5>
									{{
										$t(
											'navigationAusbildungsgrade.kampfphasen.phasen.phase4.title'
										)
									}}
								</h5>
								<div>
									{{
										$t(
											'navigationAusbildungsgrade.kampfphasen.phasen.phase4.description'
										)
									}}
								</div>
							</li>
							<li>
								<h5>
									{{
										$t(
											'navigationAusbildungsgrade.kampfphasen.phasen.phase5.title'
										)
									}}
								</h5>
								<div>
									{{
										$t(
											'navigationAusbildungsgrade.kampfphasen.phasen.phase5.description'
										)
									}}
								</div>
							</li>
							<li>
								<h5>
									{{
										$t(
											'navigationAusbildungsgrade.kampfphasen.phasen.phase6.title'
										)
									}}
								</h5>
								<div>
									{{
										$t(
											'navigationAusbildungsgrade.kampfphasen.phasen.phase6.description'
										)
									}}
								</div>
							</li>
						</ul>
					</div>
					<div>
						{{ $t('navigationAusbildungsgrade.text.absatz6') }}
						{{
							$t(
								'navigationAusbildungsgrade.ausbildergrade.description.absatz1'
							)
						}}
					</div>
				</div>
			</div>
		</div>
		<tab-view-grades />
		<div class="system-action-button">
			<yellow-button
				:title="$t('navigationAusbildungsgrade.buttons.button1')"
				pathName="Editorial"
			/>
		</div>
		<div class="container">
			<div class="row align-items-center h-50">
				<div class="py-5 col-9">
					<div class="mb-3">
						{{ $t('navigationAusbildungsgrade.text.absatz7') }}
						{{ $t('navigationAusbildungsgrade.text.absatz8') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationAusbildungsgrade.text.absatz9') }}
					</div>
					<div>
						{{ $t('navigationAusbildungsgrade.text.absatz10') }}
					</div>
					<div>
						{{ $t('navigationAusbildungsgrade.text.absatz11') }}
						{{ $t('navigationAusbildungsgrade.text.absatz12') }}
					</div>
				</div>
			</div>
		</div>
		<tab-view-grades-ausbilder />
	</div>
</template>

<script>
import kompetenzpyramide from '@/assets/kompetenzpyramide_weiß.png'
import logo from '@/assets/logo.png'
import TabViewGrades from '@/components/TabViewGrades.vue'
import TabViewGradesAusbilder from '@/components/TabViewGradesAusbilder.vue'
import systemMixin from '@/views/system/systemMixin.js'
import YellowButton from '@/components/YellowButton.vue'

export default {
	name: 'Ausbildungsgrade',
	components: {
		TabViewGrades,
		TabViewGradesAusbilder,
		YellowButton
	},
	data() {
		return {
			kompetenzpyramide: kompetenzpyramide,
			logo: logo
		}
	},
	mixins: [systemMixin]
}
</script>

<style scoped lang="stylus">

ul {
	list-style: none;
    margin-top: 20px;
    margin-bottom: 35px;
}

li {
	margin-top: 20px;
}

.system-action-button {
	display: flex;
	justify-content: center;
	margin-top: 6vh;
}
</style>
